import { render, staticRenderFns } from "./CourseCatalogueItem.vue?vue&type=template&id=1bb7c7ee&"
import script from "./CourseCatalogueItem.vue?vue&type=script&lang=js&"
export * from "./CourseCatalogueItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports